<div class="content p-24">
  <div class="example-viewer-wrapper mat-white-bg mat-elevation-z2">

      <div class="example-viewer-header">
          <div class="example-viewer-title">Filter</div>
      </div>
        
    <div class="example-viewer-body" >
        <div class="example-container">
            <mat-form-field>
              <input [(ngModel)]="zoektext" matInput placeholder="{{'OVERZICHT.FILTERTEXT' | translate}} ">
            </mat-form-field>    
    
            <p-multiSelect [options]="afdelingen" [(ngModel)]="selectedAfdelingen" [defaultLabel]="'OVERZICHT.FILTERAFDELING' | translate"></p-multiSelect>

            <mat-checkbox [(ngModel)]="uitdienstvalue" >Toon werknemers uit dienst</mat-checkbox>

            <div class="button-row" style = "margin-top:10px;">
              <button mat-raised-button (click)="submitFilter()">Filter</button>
            </div>
          </div>
  
    </div>
  </div>

  <div class="example-viewer-wrapper mat-white-bg mat-elevation-z2" style = "margin-top:20px;">
      <div class="example-viewer-header">
          <div class="example-viewer-title">Overzicht Medewerkers</div>
      </div>
      <div class="example-viewer-body">
          <table  mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8">

              <!--- Note that these columns can be defined in any order.
                    The actual rendered columns are set as a property on the row definition" -->
          
            
              <!-- Name Column -->
              <ng-container matColumnDef="Naam">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Naam </th>
                <td mat-cell *matCellDef="let element"> {{element.Naam}} </td>
              </ng-container>
            
              <!-- Weight Column -->
              <ng-container matColumnDef="Afdeling">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Afdeling </th>
                <td mat-cell *matCellDef="let element"> {{element.Afdeling}} </td>
              </ng-container>       
            
              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="getRecord(row.MedewerkerID)"></tr>
            </table>
        </div>
  </div>

</div>